export default __webpack_public_path__ + "static/B0295-fa8899b744739787f2eb0435be920d9e.png";